import { connect } from 'react-redux';
import ShipmentsTileGroupComponent from './ShipmentsTileGroupComponent';
import { InternalShipmentGroup } from '../../models/shipment-group';
import momentTimezone from 'moment-timezone';
import { PalletBox, PalletBoxStatus } from '../../models/pallet-box';
import { StoreState } from '../../store/state';

interface Props {
  internalShipmentGroup: InternalShipmentGroup;
  widthOffsetPx: number;
}

function sortPalletBoxesByStatus(a: PalletBox, b:PalletBox) {
  if (a.truckId && !b.truckId) {
    return 1;
  }
  if (a.status === PalletBoxStatus.OPEN && b.status === PalletBoxStatus.CLOSED) {
    return -1;
  }
  if (a.status === PalletBoxStatus.CLOSED && b.status === PalletBoxStatus.OPEN) {
    return 1;
  }

  return 0;
}

const mapStateToProps = (state: StoreState, ownProps: Props) => ({
  ...ownProps,
  now: momentTimezone.tz(state.location.localeSettings.timezone),
  internalShipmentGroup: {
    ...ownProps.internalShipmentGroup,
    palletBoxes: [...ownProps.internalShipmentGroup.palletBoxes].sort(sortPalletBoxesByStatus),
  },
});

export default connect(
  mapStateToProps,
)(ShipmentsTileGroupComponent);
